<app-toast></app-toast>

<div class="grid grid-cols-2 h-screen w-full mobile:flex">

    <div class="bg-primary-800 flex flex-col mobile:hidden">
        <div class="flex self-center mt-[15%] mx-5">
            <div class="text-white max-w-screen-sm">
                <h1 class="text-5xl font-bold">{{ 'auth.welcome_to' | transloco }}</h1>
                <pre class="whitespace-pre-line">{{ 'auth.platform_desc' | transloco }}</pre>

                <div class="flex items-center rounded-md w-[50px] h-1 gap-1">
                    <div class="bg-white rounded-full h-1 w-3/4"></div>

                    <div class="flex items-center gap-1">
                        <div class="bg-white rounded-full h-1 w-[5px] opacity-50"></div>
                        <div class="bg-white rounded-full h-1 w-[5px] opacity-50"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex-grow flex justify-end items-end">
            <img src="assets/images/signup-page/dashboard-example.png" alt="{{ 'auth.dashboard_example_image' | transloco }}"
                class="w-[80%] max-w-[1440px] h-auto max-h-[960px] pointer-events-none select-none" />
        </div>
    </div>

    <div class="bg-white p-4 z-40 px-[5%] flex flex-col h-full mobile:px-7 mobile:w-screen">
        <div class="flex w-full items-center justify-between mobile:justify-center mobile:mt-10">
            <app-logo></app-logo>
        </div>

        <div class="flex-grow flex flex-col justify-center items-center">
            <div class="max-w-screen-sm w-full self-center mt-[5vh] mobile:mt-5">
                <h1 class="text-5xl font-bold mobile:text-xl mobile:mt-[10vh]">{{ 'auth.check_email_for_temp_password' |
                    transloco }}</h1>
                <p class="mt-1 mobile:text-base">{{ 'auth.we_emailed_you_temp_password' | transloco }}</p>

                <div class="mt-[10%]">
                    <app-labeled-input labelText="{{ 'auth.email_address' | transloco }}"
                        [iconSrc]="'assets/icons/sms.svg'" iconAltText="{{ 'auth.sms_icon' | transloco }}"
                        [inputId]="'email'" [inputType]="'email'" [(inputValue)]="emailInput"
                        [errorMessage]="inputError" [isDisabled]="true"></app-labeled-input>
                </div>
                <div class="mt-2">
                    <app-labeled-input labelText="{{ 'auth.temp_password' | transloco }}"
                        [iconSrc]="'assets/icons/lock.svg'" iconAltText="{{ 'shared.lock_icon' | transloco }}"
                        [inputId]="'password'" [inputType]="'password'" [(inputValue)]="passwordInput"
                        [errorMessage]="passwordInputError" autocomplete="one-time-code"></app-labeled-input>
                </div>
                <p class="text-sm mt-4">{{ 'auth.didnt_receive_email' | transloco }}</p>

                <div class="mt-12 flex w-full justify-between">
                    <div class="w-[35%] mobile:w-[45%]">
                        <app-secondary-button buttonText="{{ 'auth.resend_email' | transloco }}"
                            borderColor="border-primary" textColor="text-primary" fontWeight="font-bold"
                            [isDisabled]="false" (buttonClick)="resendEmailButton()"></app-secondary-button>
                    </div>
                    <div class="w-[60%] mobile:w-[45%]">
                        <app-primary-button buttonText="{{ 'shared.continue' | transloco }}" [isDisabled]="continueClicked" (buttonClick)="continueButtonClick()">
                        </app-primary-button>
                    </div>
                </div>
            </div>
            <div class="hidden mt-6 mobile:block">
                <p class="font-normal">{{ 'auth.remembered_password' | transloco }} <a routerLink="/signup"
                        class="text-primary hover:underline">{{ 'auth.sign_in' | transloco }}</a></p>
            </div>

        </div>
    </div>


</div>